/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllPaymentMethods = (state) => values(get(state, ['paymentMethods', 'items']));

export const requestingPaymentMethods = (state) => (get(state, ['paymentMethods', 'requesting']));

export const errorRequestingPaymentMethods = (state) => get(state, ['paymentMethods', 'error']);